import { useContext, useEffect } from 'react';
import AppBarContext from 'context/AppBarContext';

/**
 * Fija el título de la barra superior en las pantallas del panel de empresa y limpia el
 * botón de acción heredado de la pantalla anterior (este panel es informativo: ninguna de
 * sus vistas cuelga acciones del AppBar).
 */
const useOrgPageTitle = (title) => {
  const { setAppBarButton, setAppBarTitle } = useContext(AppBarContext);

  useEffect(() => {
    setAppBarButton(null);
    setAppBarTitle(title);
  }, [title, setAppBarButton, setAppBarTitle]);
};

export default useOrgPageTitle;
